// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import Select from '../controls/Select'

const SelectWrapper: StyledComponent<Object, any, any> = styled.div`
  margin-left: -10px;
  width: 150px;
  line-height: 20px;
`

type Props = {|
  value: string,
  isLoading: boolean,
  onChange: Function
|}

type State = {|
  value: string
|}

const t = {
  russian: 'Русский',
  english: 'Английский'
}

export default class TemplateSelect extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      value: props.value
    }
  }

  componentDidUpdate() {
    if (this.props.value !== this.state.value) {
      this.props.onChange(this.state.value)
    }
  }

  render() {
    return (
      <SelectWrapper>
        <Select
          value={this.state.value}
          options={[
            { id: 'RU', name: t.russian },
            { id: 'EN', name: t.english }
          ]}
          onChange={(language) => this.setState({ value: language })}
          disabled={this.props.isLoading}
        />
      </SelectWrapper>
    )
  }
}
